import { BlockUIDesignTokens } from '@primeuix/themes/aura/blockui';

export const blockUITokens: BlockUIDesignTokens = {
  root: {
    borderRadius: '{content.border.radius}',
  },
};
